import type { FC } from 'react';
import useLayout, { LayoutType } from 'utils/layout';
import styles from './TransactionsTableHeader.module.scss';

const tableCellHeading = ['Date', 'Type', 'Method', 'Amount', 'Status'];

const TransactionsTableHeader: FC = () => {
  const layout = useLayout();

  if (layout === LayoutType.mobile) {
    return null;
  }

  return (
    <div className={styles['transactions-table-header']}>
      {tableCellHeading.map((heading) => (
        <span
          key={heading}
          className={styles['transactions-table-header-cell']}
        >
          {heading}
        </span>
      ))}
    </div>
  );
};

export default TransactionsTableHeader;
